import React from 'react';
import { Link } from 'react-router-dom';
import { SearchX } from 'lucide-react';
import { useLanguage } from '../assets/js/LanguageContext';
import '../assets/styles/SurveyAnswer.css';

/* Página 404: cualquier dirección que no existe. Mismo aspecto que el aviso de "diagnóstico no encontrado". */
const NotFound = () => {
  const { t } = useLanguage();

  return (
    <main className="tp-answer">
      <div className="tp-answer__inner tp-answer__inner--center">
        <section className="tp-answer__card tp-answer__state">
          <span className="tp-answer__state-icon" aria-hidden="true">
            <SearchX size={28} strokeWidth={1.75} />
          </span>
          <h1 className="tp-answer__question">{t('notfound_title')}</h1>
          <p className="tp-answer__hint">{t('notfound_text')}</p>
          <div className="tp-state-actions">
            <Link to="/" className="btn btn--primary">{t('notfound_home')}</Link>
            <Link to="/pin" className="btn btn--outline">{t('notfound_pin')}</Link>
          </div>
        </section>
      </div>
    </main>
  );
};

export default NotFound;
